export const headers = {
  "content-type": "application/json",
  apikey: process.env.API_KEY,
  username: process.env.API_USER_NAME,
  masterKey: true,
};

export const url = process.env.API_URL;
